import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { PlannerValidation } from './PlannerValidation';
import AllowedHandleTypeComponent from '../components/AllowedHandleTypeComponent';
import ProductInfoComponent from '../components/ProductInfoComponent';
/**
 * Validates that host front has handle product type as allowed handle type (in AllowedHandleTypeComponent)
 */
export class HandleTypeValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'HandleTypeValidation');
    }
    validateCurrentState(entity) {
        return this.validate(entity, undefined);
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        return this.validate(entity, snapActionCandidate);
    }
    validate(entity, snapActionCandidate) {
        if (!entity.hasComponent(ComponentIds.HANDLE_COMPONENT_ID) || !snapActionCandidate?.host) {
            return this.validationOK();
        }
        const handleType = entity.getComponent(ProductInfoComponent.id)
            ?.productType;
        const allowedHandleTypes = HierarchyUtils.findInUpwardsHierarchy(snapActionCandidate.host, e => e.hasComponent(AllowedHandleTypeComponent.id))?.getComponent(AllowedHandleTypeComponent.id)?.handleTypes;
        if (handleType && allowedHandleTypes) {
            return allowedHandleTypes.includes(handleType)
                ? this.validationOK()
                : this.validationFail('Door doesn´t allow specific handle type');
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=HandleTypeValidation.js.map